module.exports = __webpack_public_path__ + "img/md-file-icon.32140a93.svg";